require("./blockmapsfonts.js");

require('./navigation.js');

require('./lightbox.js');

require('./swiper.js');

require('./popup.js');

require('./scrolled.js');

require('./akkordeon.js');


const AOS = require("aos");


document.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        duration: 600,
        easing: 'ease-out-sine',
    });

   
    document.querySelectorAll("img").forEach(img => {
        img.addEventListener("load", () => {
            AOS.refresh();
        });
    });
});
